<template>
  <v-dialog
    v-model="dialog"
    height="100vh"
    @keydown="onDialogKeydown"
    @click:outside="resetModal"
    :fullscreen="$vuetify.breakpoint.mdAndDown"
    :max-width="
      e1 === 1 ? ($vuetify.breakpoint.mdAndDown ? '100%' : '80%') : '700'
    "
  >
    <v-card class="pa-0 ma-0">
      <v-card-title class="ml-4" v-show="e1 === 1 || e1 === 2"
        ><h2 class="text-h5">
          {{ title }}
        </h2>
        <v-spacer />
        <v-btn
          v-show="e1 < 3"
          title="Lukk"
          aria-label="Lukk"
          color="primary"
          @click="resetModal"
          style="z-index: 1"
          icon
        >
          <v-icon>mdi-close-circle-outline</v-icon>
        </v-btn>
      </v-card-title>

      <v-stepper v-model="e1" flat class="elevation-0 pa-0 ma-0">
        <v-stepper-items>
          <v-stepper-content flat step="1" class="pt-0">
            <export-data-step-1
              @cancel="resetModal"
              @step-completed="onStep1Completed"
              :show="dialog"
            />
          </v-stepper-content>

          <v-stepper-content step="2" class="pt-0">
            <export-data-step-2
              @cancel="e1 = 1"
              :time-series-not-available-for-export="
                timeSeriesNotAvailableForExport
              "
              :timeseries-count="numberOfTimesSeriesMarkedForExport"
              @step-completed="onStep2Completed"
              :init-from-date="fromDate"
              :init-to-date="toDate"
              :show-previous-button="singleTimeserie === null"
            />
          </v-stepper-content>

          <v-stepper-content step="3">
            <export-data-step-3
              @cancel="e1 = 2"
              :loading="exportActive"
              :completed="exportFinished"
              :error="errorOccured"
              @step-completed="resetModal"
              @export-data="downloadFile"
            />
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </v-card>
  </v-dialog>
</template>
<script>
import ExportDataStep1 from "./ExportDataStep1.vue";
import ExportDataStep2 from "./ExportDataStep2.vue";
import ExportDataStep3 from "./ExportDataStep3.vue";
import XLSX from "xlsx";
import ChartService from "../../services/ChartService";
import { mapState } from "vuex";

export default {
  name: "ExportData",
  components: {
    ExportDataStep1,
    ExportDataStep2,
    ExportDataStep3,
  },
  props: {
    show: {
      type: Boolean,
    },
    singleTimeserie: {
      type: Object,
      default: null,
    },
    title: {
      type: String,
      default: "Dataeksport",
    },
  },
  data() {
    return {
      Datas: {},
      dateRange: ["2019-09-10", "2019-09-20"],
      query: null,
      queryTask: null,
      tableQueries: [],
      tidsrom: [],
      exportActive: false,
      exportFinished: false,
      count: 0,
      activeTab: null,
      e1: 1,
      columns: null,
      headings: null,
      ekskluderteTidsserier: Array,
      pickedExportType: "withoutTimeValues",
      errorOccured: false,
      exportSelected: true,
      dialog: false,
      timeSeriesMarkedForExport: [],
      timeSeriesOtherActorsMarkedForExport: [],
      fromDate: new Date(new Date().setMonth(new Date().getMonth() - 2))
        .toISOString()
        .substr(0, 10),
      toDate: new Date().toISOString().substr(0, 10),
      lastExportedWorkbook: null,
      exportButtonFocused: false,
      timeSeriesNotAvailableForExport: [],
      parametersThatCannotBeExported: ["Vanntemperatur", "Markfuktighet"],
      numberOfTimesSeriesMarkedForExport: 0,
    };
  },
  mounted: function() {
    this.dialog = this.show;
  },
  computed: {
    ...mapState([
      "chartDateRange",
      "selectedTimeSeries",
      "selectedTimeSeriesOtherActors",
      "selectedColumns",
      "selectedColumnsOtherActors",
      "showStationsFromOtherActors",
      "vheaders",
      "otherTimeseriesHeaders",
    ]),
  },
  watch: {
    chartDateRange: function(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.dateRange = newVal;
        var tzoffset = new Date().getTimezoneOffset() * 60000; //offset in milliseconds
        this.fromDate = new Date(newVal.start.getTime() - tzoffset)
          .toISOString()
          .substring(0, 10);
        this.toDate = new Date(newVal.end.getTime() - tzoffset)
          .toISOString()
          .substring(0, 10);
      }
    },
    showStationsFromOtherActors: function(newVal, oldVal) {
      if (newVal !== oldVal) {
        let existingTableQueryIndex = this.tableQueries.findIndex((item) =>
          item.queryTask.url.toLowerCase().includes("xgeo"),
        );
        this.tableQueries.splice(existingTableQueryIndex, 1);
      }
    },
    show: function(newVal) {
      if (newVal) {
        if (this.singleTimeserie) {
          this.timeSeriesMarkedForExport = [];
          this.timeSeriesOtherActorsMarkedForExport = [];
          if (this.singleTimeserie.isNveTimeseries) {
            this.timeSeriesMarkedForExport.push(this.singleTimeserie);
          } else {
            this.timeSeriesOtherActorsMarkedForExport.push(
              this.singleTimeserie,
            );
          }
          this.numberOfTimesSeriesMarkedForExport =
            this.timeSeriesMarkedForExport.length +
            this.timeSeriesOtherActorsMarkedForExport.length;
          this.e1 = 2;

          this.timeSeriesNotAvailableForExport = this.getVerticalTimeSeries(
            this.timeSeriesMarkedForExport,
          );
        }
        this.dialog = true;
      }
    },
  },
  methods: {
    onStep1Completed(evt) {
      this.timeSeriesMarkedForExport = evt.timeSeriesMarkedForExport;
      this.timeSeriesOtherActorsMarkedForExport =
        evt.timeSeriesOtherActorsMarkedForExport;
      this.numberOfTimesSeriesMarkedForExport =
        this.timeSeriesMarkedForExport.length +
        this.timeSeriesOtherActorsMarkedForExport.length;
      this.e1 = 2;
      this.timeSeriesNotAvailableForExport = this.getVerticalTimeSeries(
        this.timeSeriesMarkedForExport,
      );
    },
    getVerticalTimeSeries(timeseries) {
      return timeseries.filter(
        (timeserie) => parseInt(timeserie.structure) === 3,
      );
    },
    getTimeSeriesThatSupportsTimeValuesExport(timeseries) {
      return timeseries.filter(
        (timeserie) => parseInt(timeserie.structure) === 2,
      );
    },
    onDialogKeydown(evt) {
      if (evt.code === "Escape") {
        this.resetModal();
      }
    },
    updateNumberOfTimeSeries(newCount) {
      this.count = newCount;
    },
    resetModal: function() {
      this.activeTab = null;
      this.exportActive = false;
      this.exportFinished = false;
      this.exportSelected = false;
      this.errorOccured = false;
      this.dialog = false;

      setTimeout(() => {
        this.e1 = 1;
        this.$emit("dialog-closed");
      }, 200);
    },
    onStep2Completed: function(evt) {
      this.pickedExportType = evt.pickedExportType;
      this.fromDate = evt.fromDate;
      this.toDate = evt.toDate;
      this.e1 = 3;
      if (this.pickedExportType == "withoutTimeValues") {
        this.downloadTimeseriesMetadata();
      } else {
        this.downloadTimeseriesMeasurements();
      }
    },
    getDatesAsText: function(fromDate, toDate) {
      let startDate = "'" + fromDate + " 00:01:00" + "'";
      let endDate = "'" + toDate + " 23:59:00" + "'";
      return [startDate, endDate];
    },
    normalizeAttributes: function(attributes) {
      // Sjekk om vi har lowercase-feltnavn (ny karttjeneste)
      const hasLowercaseFields =
        attributes.hasOwnProperty("stasjonnr") ||
        attributes.hasOwnProperty("stasjonparameter") ||
        attributes.hasOwnProperty("objectid");

      // Hvis allerede normalisert eller gammel tjeneste, returner uendret
      if (!hasLowercaseFields) {
        return attributes;
      }

      // Normaliser fra lowercase til camelCase
      const fieldMapping = {
        objectid: "OBJECTID",
        stasjonnr: "stasjonNr",
        stasjonnavn: "stasjonNavn",
        stasjonparameter: "stasjonParameter",
        stasjonparameterkode: "stasjonParameterKode",
        versjon: "versjon",
        stasjontype: "stasjonType",
        datafradato: "dataFraDato",
        datatildato: "dataTilDato",
        status: "status",
        sanntid: "sanntid",
      };

      const normalizedAttrs = {};
      for (const key in attributes) {
        const mappedKey = fieldMapping[key.toLowerCase()] || key;
        normalizedAttrs[mappedKey] = attributes[key];
      }
      return normalizedAttrs;
    },
    getTimeSeriesObjectIDs: function(timeSeries) {
      return timeSeries.map((t) => t.OBJECTID).join(",");
    },
    downloadTimeseriesMetadata: function() {
      this.Datas = {};
      this.exportActive = true;
      let promises = [];

      this.tableQueries.forEach((tableQuery) => {
        let tableQueryCopy = JSON.parse(JSON.stringify(tableQuery));

        let allHeaders;
        if (tableQuery.queryTask.url.toLowerCase().includes("xgeo")) {
          tableQueryCopy.selectedTimeSeries = this.timeSeriesOtherActorsMarkedForExport;
          tableQueryCopy.columns = this.selectedColumnsOtherActors;
          allHeaders = this.otherTimeseriesHeaders;
        } else {
          tableQueryCopy.selectedTimeSeries = this.timeSeriesMarkedForExport;
          tableQueryCopy.columns = this.selectedColumns;
          allHeaders = this.vheaders;
        }

        if (tableQueryCopy.selectedTimeSeries.length === 0) {
          return;
        }

        let query = tableQueryCopy.query;

        if (tableQueryCopy.selectedTimeSeries.length > 0) {
          query.where =
            "OBJECTID IN (" +
            this.getTimeSeriesObjectIDs(tableQueryCopy.selectedTimeSeries) +
            ")";
        }

        promises.push(
          tableQuery.queryTask.execute(query).then((result) => {
            return new Promise((resolve) => {
              let excelData = [[]];

              for (let i = 0; i < tableQueryCopy.columns.length; i++) {
                if (tableQueryCopy.columns[i].value === "data-table-expand") {
                  continue;
                }
                excelData[0].push(tableQueryCopy.columns[i].text);
              }

              result.features.forEach((feature) => {
                let row = [];
                for (let i = 0; i < tableQueryCopy.columns.length; i++) {
                  if (tableQueryCopy.columns[i].value === "data-table-expand") {
                    continue;
                  }
                  let value =
                    feature.attributes[tableQueryCopy.columns[i].value];

                  if (value == null) {
                    value = "Ikke angitt";
                    row.push(value);
                    continue;
                  }
                  if (
                    tableQueryCopy.columns[i].value
                      .toLowerCase()
                      .includes("dato") ||
                    tableQueryCopy.columns[i].value
                      .toLowerCase()
                      .includes("date") ||
                    tableQueryCopy.columns[i].value
                      .toLowerCase()
                      .includes("dt_")
                  ) {
                    let date = new Date(value);
                    value = date;
                  } else {
                    value = this.getFormattedValue(
                      tableQueryCopy.columns[i].value,
                      value,
                      allHeaders,
                    );
                  }

                  row.push(value);
                }
                excelData.push(row);
              });

              resolve(excelData);
            });
          }),
        );
      });

      Promise.all(promises).then((result) => {
        var wb = XLSX.utils.book_new();
        result.forEach((excelData, index) => {
          let sheet = XLSX.utils.aoa_to_sheet(excelData);
          XLSX.utils.book_append_sheet(
            wb,
            sheet,
            "Tidsserier side " + (index + 1),
          );
        });
        this.lastExportedWorkbook = wb;
        XLSX.writeFile(
          wb,
          "seriekart_tidsserie_eksport_" +
            new Date().toLocaleDateString().slice(0, 10) +
            ".xlsx",
        );
        this.exportActive = false;
        this.exportFinished = true;
        this.exportSelected = false;
      });
    },
    getFormattedValue: function(key, rawValue, headers) {
      let attributes = headers.filter((item) => item.value === key);

      if (attributes.length !== 0) {
        let attribute = attributes[0];
        if (Object.prototype.hasOwnProperty.call(attribute, "valueMapping")) {
          let values = attribute.valueMapping.filter((value) => {
            return (
              value.valueFrom ===
              (this.isInt(rawValue) ? "" + rawValue + "" : rawValue)
            );
          });
          if (values.length > 0) {
            return values[0].valueTo;
          }
        }

        if (
          (this.isInt(rawValue) || this.isFloat(rawValue)) &&
          Math.round(rawValue) !== rawValue
        ) {
          return (Math.round(rawValue * 100) / 100).toFixed(2);
        } else {
          return rawValue;
        }
      } else {
        return rawValue;
      }
    },
    isInt: function(n) {
      return Number(n) === n && n % 1 === 0;
    },
    isFloat: function(n) {
      return Number(n) === n && n % 1 !== 0;
    },
    getDates: function(startDateISOString, stopDateISOString) {
      let startDate = new Date(startDateISOString);
      let stopDate = new Date(stopDateISOString);

      Date.prototype.addDays = function(days) {
        var date = new Date(this.valueOf());
        date.setDate(date.getDate() + days);
        return date;
      };
      var dateArray = new Array();
      var currentDate = startDate;
      while (currentDate <= stopDate) {
        dateArray.push(new Date(currentDate));
        currentDate = currentDate.addDays(1);
      }
      return dateArray;
    },
    downloadTimeseriesMeasurements: function() {
      this.Datas = {};
      this.exportActive = true;

      let chartService = new ChartService();

      let tableQueryPromises = [];
      this.tableQueries.forEach((tableQuery) => {
        tableQueryPromises.push(
          new Promise((resolve, reject) => {
            let tableQueryCopy = JSON.parse(JSON.stringify(tableQuery));

            if (tableQuery.queryTask.url.toLowerCase().includes("xgeo")) {
              tableQueryCopy.selectedTimeSeries = this.timeSeriesOtherActorsMarkedForExport;
              tableQueryCopy.columns = this.selectedColumnsOtherActors;
              tableQueryCopy.external = true;
            } else {
              tableQueryCopy.selectedTimeSeries = this.getTimeSeriesThatSupportsTimeValuesExport(
                this.timeSeriesMarkedForExport,
              );
              tableQueryCopy.columns = this.selectedColumns;
              tableQueryCopy.external = false;
            }

            if (tableQueryCopy.selectedTimeSeries.length === 0) {
              resolve();
              return;
            }

            if (tableQueryCopy.selectedTimeSeries.length > 0) {
              tableQueryCopy.query.where =
                "OBJECTID IN (" +
                this.getTimeSeriesObjectIDs(tableQueryCopy.selectedTimeSeries) +
                ")";
            }

            tableQuery.queryTask
              .execute(tableQueryCopy.query)
              .then((result) => {
                let promises = [];

                // Normaliser attributter fra ny karttjeneste (lowercase → camelCase)
                result.features.forEach((feature) => {
                  if (
                    feature &&
                    feature.attributes &&
                    !tableQueryCopy.external
                  ) {
                    feature.attributes = this.normalizeAttributes(
                      feature.attributes,
                    );
                  }
                });

                result.features.forEach((feature) => {
                  let stasjonNr = tableQueryCopy.external
                    ? feature.attributes.STASJONID
                    : feature.attributes.stasjonNr;
                  let stasjonParameter = tableQueryCopy.external
                    ? feature.attributes.PARAMETER
                    : feature.attributes.stasjonParameterKode;
                  let versjon = tableQueryCopy.external
                    ? feature.attributes.VERSJON
                    : feature.attributes.versjon;

                  promises.push(
                    chartService.getChartValues(
                      stasjonNr,
                      stasjonParameter,
                      versjon,
                      this.getDatesAsText(this.fromDate, this.toDate),
                      tableQueryCopy.external,
                    ),
                  );
                });

                Promise.allSettled(promises)
                  .then((values) => {
                    let self = this;
                    values.forEach((tidsserie, valueIndex) => {
                      if (tidsserie.status === "rejected") {
                        console.error("eksport feilet");
                        return;
                      }
                      tidsserie = tidsserie.value;
                      let sheetName = tableQueryCopy.external
                        ? result.features[valueIndex].attributes.PARAMETERNAVN
                        : result.features[valueIndex].attributes
                            .stasjonParameter;

                      // eslint-disable-next-line no-useless-escape
                      sheetName = sheetName
                        // eslint-disable-next-line no-useless-escape
                        .replace(/[*?\[\]\\\/]/gi, "")
                        .substring(0, 30);

                      if (
                        self.Datas[sheetName] &&
                        Object.keys(self.Datas[sheetName]).length > 0
                      ) {
                        let arr = self.getFormattedExcelData(
                          false,
                          tidsserie[0],
                          this.getTimeseriesKey(result.features[valueIndex]),
                        );

                        arr.forEach((element, index) => {
                          let theKey = Object.keys(element)[0];

                          let theValue = element[Object.keys(element)[0]];
                          if (self.Datas[sheetName][index]) {
                            self.Datas[sheetName][index][theKey] = theValue;
                          }
                        });
                      } else {
                        self.Datas[sheetName] = self.getFormattedExcelData(
                          true,
                          tidsserie[0],
                          this.getTimeseriesKey(result.features[valueIndex]),
                        );
                      }
                    });

                    this.exportSelected = false;

                    resolve();
                  })
                  .catch((error) => {
                    reject(error);
                  });
              });
          }),
        );
      });

      Promise.all(tableQueryPromises)
        .then(() => {
          this.exportDataToXls();
        })
        .catch((error) => {
          console.log(error);
          this.exportActive = false;
          this.exportFinished = true;
          this.errorOccured = error;
        });
    },
    getTimeseriesKey: function(timeserie) {
      if (timeserie.attributes.hasOwnProperty("compoundKey20")) {
        return timeserie.attributes.compoundKey20;
      } else {
        let key = timeserie.attributes.OBJECTID;
        if (timeserie.attributes.hasOwnProperty("EKLIMA_ELEMENT")) {
          key =
            key + ", EKLIMA_ELEMENT: " + timeserie.attributes.EKLIMA_ELEMENT;
        }
        return key;
      }
    },
    getFormattedExcelData: function(addDates, tidsserie, ID) {
      let arr = [];
      if (tidsserie.SeriesPoints.length === 0) {
        let datesArray = this.getDates(this.fromDate, this.toDate);

        datesArray.forEach((date) => {
          let verdi = "Ingen data";
          let serie = {};

          if (addDates) {
            serie["Dato"] =
              date.getDate() +
              "." +
              (date.getMonth() + 1) +
              "." +
              date.getFullYear();
          }
          serie[tidsserie.LegendText + " (ID: " + ID + ")"] = verdi;
          arr.push(serie);
        });
      } else {
        tidsserie.SeriesPoints.forEach((point) => {
          let verdi = point.Value == null ? "Ingen data" : point.Value;
          let dato = new Date(
            parseInt(point.Key.substring(6, point.Key.length - 2)),
          );
          let serie = {};
          if (addDates) {
            serie["Dato"] =
              dato.getDate() +
              "." +
              (dato.getMonth() + 1) +
              "." +
              dato.getFullYear();
          }

          serie[tidsserie.LegendText + " (ID: " + ID + ")"] = verdi;
          arr.push(serie);
        });
      }
      return arr;
    },
    exportDataToXls: function() {
      var wb = XLSX.utils.book_new();
      for (var key in this.Datas) {
        var worksheet = XLSX.utils.json_to_sheet(this.Datas[key]);
        XLSX.utils.book_append_sheet(wb, worksheet, key);
      }
      this.lastExportedWorkbook = wb;
      XLSX.writeFile(
        wb,
        "seriekart_tidsserie_eksport_" +
          new Date().toLocaleDateString().slice(0, 10) +
          ".xlsx",
      );
      this.exportActive = false;
      this.exportFinished = true;
    },
    downloadFile: function() {
      XLSX.writeFile(
        this.lastExportedWorkbook,
        "seriekart_tidsserie_eksport_" +
          new Date().toLocaleDateString().slice(0, 10) +
          ".xlsx",
      );
    },
    oppdaterQuery: function(nyQuery, nyQueryTask) {
      let existingTableQueryIndex = this.tableQueries.findIndex(
        (item) => item.queryTask.url === nyQueryTask.url,
      );
      let tableQuery = {
        query: JSON.parse(JSON.stringify(nyQuery)),
        queryTask: nyQueryTask,
      };

      tableQuery.query.start = null;
      if (existingTableQueryIndex === -1) {
        this.tableQueries.push(tableQuery);
      } else {
        this.tableQueries[existingTableQueryIndex] = tableQuery;
      }
    },
  },
  created() {
    this.$eventHub.$on("query-changed", this.oppdaterQuery);

    this.$eventHub.$on(
      "timeseries-count-change",
      this.updateNumberOfTimeSeries,
    );
  },
};
</script>
<style>
.popover-container input {
  min-width: 100px !important;
}
@import "~vue-multiselect/dist/vue-multiselect.min.css";
.export {
  margin-right: 10px;
  display: inline;
}

.exportReady {
  background: #007bff !important;
  color: white !important;
}

.range-slider {
  margin-top: 50px;
  margin-left: 15px;
}
</style>
